module.exports = __webpack_public_path__ + "audio-e816cad8c36d.m4a";